export default {
  coluna_reordenada_com_sucesso: 'Coluna reordenada com sucesso!',
  nenhum_registro_foi_encontrado: 'Nenhum registro foi encontrado.',
  paginal_atual_template: '({currentPage} de {totalPages})',
  selecionar_colunas: 'Selecionar colunas',
  colunas: 'Colunas',
};
